import React, { useEffect, useState } from "react";
import { Table, Pagination, Form, InputGroup, Button } from "react-bootstrap";
import { useLoader } from "../../context/LoaderContext";
import axiosUserInstance from "../../axiosUserInstance";
import AdminLayout from "./AdminLayout";

const UserList = () => {
  const { setLoading } = useLoader();
  const [userList, setUserList] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    fetchUserData(page, searchText);
  }, [page, searchText]);

  const fetchUserData = async (pageNo, search = "") => {
    try {
      setLoading(true);
      const response = await axiosUserInstance.get(
        `/user/all?page=${pageNo}&limit=${limit}&search=${search}`
      );
      if (response?.status === 200) {
        const { data, pagination } = response.data;
        setUserList(data);
        setTotalPages(pagination.totalPages);
      }
    } catch (err) {
      console.error("Error fetching users:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
    setPage(1); // reset to first page when searching
  };

  return (
    <AdminLayout>
      <div className="container mt-4">
        <div className="d-flex align-items-center flex-wrap gap-3 justify-content-between mb-3">
          <h4>User Management ({userList.length})</h4>

          {/* Search Bar */}
          <InputGroup className="w-50">
            <Form.Control
              placeholder="Search by name, username, or email"
              value={searchText}
              onChange={handleSearchChange}
            />
            <Button
              variant="secondary"
              onClick={() => fetchUserData(1, searchText)}
            >
              Search
            </Button>
          </InputGroup>
        </div>

        <Table striped bordered hover responsive className="shadow-sm">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>UserName</th>
              <th>Email</th>
              <th>Role</th>
              <th>Plan</th>
              <th>Status</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {userList.length > 0 ? (
              userList.map((user, index) => (
                <tr key={user._id}>
                  <td>{(page - 1) * limit + index + 1}</td>
                  <td>{user.name || "-"}</td>
                  <td>{user.userName}</td>
                  <td>{user.email}</td>
                  <td>{user.roleId}</td>
                  <td>{user.planType?.type || user.planType}</td>
                  <td>
                    <span
                      className={`badge ${
                        user.status === "active" ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {user.status}
                    </span>
                  </td>
                  <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No users found
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        {/* Pagination */}
        <div className="d-flex justify-content-center">
          <Pagination>
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i + 1}
                active={i + 1 === page}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>
    </AdminLayout>
  );
};

export default UserList;
